import { render, staticRenderFns } from "./EnrollCourseStudentList.vue?vue&type=template&id=3551a760"
import script from "../../services/student/enroll-student-course.js?vue&type=script&lang=js&external"
export * from "../../services/student/enroll-student-course.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports